<template>
  <v-card height="100%">
    <map-component
      :map-id="mapId"
      style="height: 100%;"
      :fullscreen-button="true"
      :draw-enabled="true"
    />
  </v-card>
</template>

<script>
import MapComponent from "../../map/Map";
import nanoid from "nanoid";

export default {
  data() {
    return {
      mapId: null,
      dataSources: [
        {
          name: "ספק נוכחי",
          parentId: this.$route.params.id,
          get: {
            url: process.env.API_BASE_URL + "/map-features",
            method: "get",
            params: {
              q: JSON.stringify({
                partner: this.$route.params.id
              }),
              limit: 0
            },
            toGeoJson: data => {
              return {
                type: "FeatureCollection",
                features: data.results.map(item => {
                  let feature = item.feature;
                  feature.properties.id = item._id;
                  return feature;
                })
              };
            }
          },
          create: {
            url: process.env.API_BASE_URL + "/map-features",
            method: "post",
            params: {},
            featureToObject: data => {
              delete data.meta;
              return {
                partner: this.$route.params.id,
                feature: data,
                _id: data.properties.id
              };
            }
          },
          update: {
            url: process.env.API_BASE_URL + "/map-features",
            method: "patch",
            params: {},
            featureToObject: data => {
              delete data.meta;
              return {
                partner: this.$route.params.id,
                feature: data,
                _id: data.properties.id
              };
            }
          },
          remove: {
            url: process.env.API_BASE_URL + "/map-features",
            method: "delete"
          },
          defaultProperties: {
            markerType: "",
            iconColor: "white",
            color: "black"
          },
          editable: true,
          isActive: true
        }
      ]
    };
  },

  computed: {},

  methods: {
    setDataSources() {
      this.$store.commit("maps/APPEND_DATA_SOURCES_GROUPS", {
        mapId: this.mapId,
        val: [
          {
            title: "שכבת ספק",
            dataSources: this.dataSources
          }
        ]
      });
    }
  },

  beforeMount() {
    this.mapId = nanoid();
  },

  mounted() {
    this.setDataSources();
  },

  components: {
    MapComponent
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/partners/partner/Map.vue